import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--small",
  "use": "icon-arrow--small-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-arrow--small\"><path d=\"m4.699 11.423-.021-1.336 4.253-.202L2.885 3.84l.955-.955 6.045 6.046.202-4.253 1.336.02-.329 6.396-6.395.33Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol